module.exports = __webpack_public_path__ + "static/Coke_Pay_It_Forward-40b021f3a14232ad8ecb300ccfcbfd08.mp4";